import { render, staticRenderFns } from "./StopTable.vue?vue&type=template&id=5149f992&scoped=true&"
import script from "./StopTable.vue?vue&type=script&lang=js&"
export * from "./StopTable.vue?vue&type=script&lang=js&"
import style0 from "./StopTable.vue?vue&type=style&index=0&id=5149f992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5149f992",
  null
  
)

export default component.exports